<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
    <p style="color: white">Please Wait...While Fetching Settings</p>
</ngx-spinner>

<div class="header_second">
    <div class="Dashboard_head ">Send Push Notification
    </div>
</div>
<div class="d-flex justify-content-center">
    <mat-card class="col-lg-9 col-sm-12">
        <mat-card-content>
            <div class="row ">

                <mat-form-field appearance="outline">
                    <mat-label>Title</mat-label>
                    <input matInput [(ngModel)]="title" placeholder="Enter Title">
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Message</mat-label>
                    <input [(ngModel)]="msg" matInput placeholder="Enter Message">
                </mat-form-field>

            </div>
        </mat-card-content>
        <mat-card-actions align="end">
            <button mat-raised-button color="primary" (click)="SendPush()">Send <mat-icon>send</mat-icon></button>
        </mat-card-actions>
    </mat-card>
</div>